import { Box, Container, Typography } from "@mui/material";
import { motion } from "framer-motion";
import why1 from "../../assets/New/why1.png";
import why2 from "../../assets/New/why2.png";
import why3 from "../../assets/New/why3.png";

const items = [
  {
    title: "Qualified Advisors",
    desc: "Experienced advisors with deep market intelligence.",
    image: why1,
  },
  {
    title: "Exceptional Service",
    desc: "A refined, relationship-driven real estate experience.",
    image: why2,
  },
  {
    title: "Dedicated Support",
    desc: "White-glove guidance from first call to final signature.",
    image: why3,
  },
];

export default function WhyChooseUs() {
  return (
    <Box
      sx={{
        backgroundColor: "var(--color-bg)",
        py: { xs: 3, md: 6 },
        position: "relative",
      }}
    >
      <Container maxWidth="lg">
        {/* HEADER */}
        <Box sx={{ textAlign: "center", mb: { xs: 4, md: 4 } }}>
          <Typography
            sx={{
              color: "var(--color-gold)",
              fontSize: 11,
              letterSpacing: "0.35em",
              mb: 2,
            }}
          >
            OUR PHILOSOPHY
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: "1.8rem", md: "3rem" },
              fontWeight: 500,
              lineHeight: 1.15,
              mb: 0,
            }}
          >
            Exceptional Homes.
            <Box component="span" sx={{ color: "var(--color-gold)", ml: 1 }}>
              Intelligent Advisory.
            </Box>
          </Typography>

          <Typography
            sx={{
              color: "var(--color-text-muted)",
              maxWidth: 560,
              mx: "auto",
              fontSize: 14,
              lineHeight: 1.7,
            }}
          >
            A refined approach to buying, investing, and reselling premium real
            estate — guided by insight, discretion, and experience.
          </Typography>
        </Box>

        {/* CARDS */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: 3,
          }}
        >
          {items.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              viewport={{ once: true }}
              style={{ display: "flex" }} // motion ONLY animates
            >
              {/* WIDTH CONTROLLER */}
              <Box
                sx={{
                  width: {
                    xs: "100%", // 📱 mobile: full width
                    md: 350, // 💻 desktop: 3 in a row
                  },
                  maxWidth: "100%",
                }}
              >
                {/* CARD */}
                <Box
                  sx={{
                    width: "100%",
                    borderRadius: "24px",
                    overflow: "hidden",
                    backgroundColor: "#fff",
                    transition: "transform 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-6px)",
                    },
                  }}
                >
                  {/* IMAGE */}
                  <Box
                    component="img"
                    src={item.image}
                    alt={item.title}
                    sx={{
                      width: "100%",
                      height: 240,
                      objectFit: "cover",
                    }}
                  />

                  {/* CONTENT */}
                  <Box sx={{ p: 3 }}>
                    <Typography
                      sx={{
                        fontSize: 18,
                        fontWeight: 500,
                        mb: 1,
                      }}
                    >
                      {item.title}
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: 14,
                        color: "var(--color-text-muted)",
                        lineHeight: 1.6,
                      }}
                    >
                      {item.desc}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </motion.div>
          ))}
        </Box>
      </Container>
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: "5%",
          right: "5%",
          height: "1px",
          background:
            "linear-gradient(90deg, transparent, var(--color-gold), transparent)",
          opacity: 0.6,
        }}
      />
    </Box>
  );
}
